import { createSelector, createSlice } from '@reduxjs/toolkit';
import { RootState } from 'app/store';
import { ICurrenciesSliceInitialState } from './currenciesTypes';
import { getCurrencies } from './currenciesActions';
import { isRejectedAction } from 'features/sliceHelpers';

const initialState: ICurrenciesSliceInitialState = {
  currencies: [],
  isLoading: false,
};

export const currenciesListSlice = createSlice({
  name: '@@currenciesList',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getCurrencies.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(getCurrencies.fulfilled, (state, action) => {
      state.currencies = action.payload;
    });
    builder.addMatcher(isRejectedAction, (state) => {
      state.isLoading = false;
    });
  },
});

export const currenciesListSelector = createSelector(
  [(state: RootState) => state.currenciesList.currencies],
  (currencies) => currencies
);